import React from "react";
import PropTypes from "prop-types";
import { Input } from "antd";

const getMandatoryField = (man) => {
  if (man) {
    return <span className="text-red-600"> *</span>;
  }
};
const getFieldError = (error) => {
  if (error) {
    return <span className="text-red-600"> {error} </span>;
  }
};
const TextInput = ({mandatory, error, handleValues=()=>{}, placeHolder, label, keyVal, maxLength, ...restProps}) => {
  const mandatoryField = getMandatoryField(mandatory);
  const fieldError = getFieldError(error);

  return (
    <>
      <label className="text-gray-600 block text-14px">
        {label}
        {mandatoryField}
        {fieldError}
      </label>
      {
        restProps?.type === 'textarea' ? (
          <Input.TextArea
                showCount={true}
                maxLength={maxLength ? maxLength : 150}
                style={{ height: 120, resize: 'none' }}
                onChange={handleValues}
                {...restProps}
              />
        ) : (
          <input
          placeholder={placeHolder ? placeHolder : ""}
          onChange={(event) =>
            handleValues(keyVal, event.target.value)
          }
          className="font-montserrat text-16px text-input-color text-sm border border-grey-600 focus:ring-indigo-500 outline-none focus:border-indigo-500 block w-full border-gray-300 p-2"
          {...restProps}
        />
        )
      }
      
    </>
  );
};

TextInput.propTypes = {
  mandatory: PropTypes.bool,
  error: PropTypes.string,
  handleValues: PropTypes.func,
  placeHolder: PropTypes.string,
  label: PropTypes.string,
  keyVal: PropTypes.string,
  value: PropTypes.string,
};

export default TextInput;
